import { render, staticRenderFns } from "./DlqiPhase.vue?vue&type=template&id=354c3604&scoped=true&"
import script from "./DlqiPhase.vue?vue&type=script&lang=js&"
export * from "./DlqiPhase.vue?vue&type=script&lang=js&"
import style0 from "./DlqiPhase.vue?vue&type=style&index=0&id=354c3604&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "354c3604",
  null
  
)

export default component.exports